import { gql } from '@apollo/client';

export const QUERY_DASHBOARD_METRIC_ANNOTATIONS = gql`
    query QueryDashboardMetricAnnotations($pageKey: String!, $dateKeys: [String!]!) {
        queryDashboardMetricAnnotations(pageKey: $pageKey, dateKeys: $dateKeys) {
            id
            pageKey
            dateKey
            columnType
            hubId
            metricKey
            dimensions
            content
            createdById
            createdByName
            updatedById
            updatedByName
            createdAt
            updatedAt
        }
    }
`;

export interface DashboardMetricAnnotationTypeResponse {
    id: string;
    pageKey: string;
    dateKey: string;
    columnType: string;
    hubId: string;
    metricKey: string;
    dimensions: string;
    content: string;
    createdById: string;
    createdByName: string;
    updatedById?: string | null;
    updatedByName?: string | null;
    createdAt: string;
    updatedAt: string;
}

export interface QueryDashboardMetricAnnotationsResponse {
    queryDashboardMetricAnnotations: DashboardMetricAnnotationTypeResponse[];
}

export interface QueryDashboardMetricAnnotationsVariables {
    pageKey: string;
    dateKeys: string[];
}
